// Answers the lead agent captured on the phone for the funnel's Leadservice
// questions. The backend stores them on QUALIFIED only
// (lead.leadServiceResponses). Kept in the stored order, which is the order
// ContactCloud shows under "Telefonische Fragen (Leadservice)".
export const getLeadServiceAnswers = (lead) =>
  Array.isArray(lead?.leadServiceResponses)
    ? lead.leadServiceResponses.filter((qa) => qa?.question)
    : [];
